export default "__VITE_ASSET__8d5c8e5a__"